import React, { useState, useEffect } from 'react';

const Payroll = () => {
    // Global Settings for the current cycle
    const [periodStr, setPeriodStr] = useState('April 16-30, 2026');
    const [standardDays, setStandardDays] = useState(11);
    const [isSaved, setIsSaved] = useState(false);

    // Mock Database of Active Teachers (This will later be replaced by an axios fetch)
    const initialStaff = [
        { id: 1, name: 'Divina T. Donsig', rate: 625 },
        { id: 2, name: 'Alyssa L. Tan', rate: 625 },
        { id: 3, name: 'Kristanya T. Devibar', rate: 525 },
        { id: 4, name: 'Kim Andrian L. Tan', rate: 450 },
        { id: 6, name: 'Liezl M. Benlot', rate: 525 }
    ];

    // The Master Ledger State
    const [ledger, setLedger] = useState([]);

    // Initialize the ledger with default zero values when the component loads
    useEffect(() => {
        const freshLedger = initialStaff.map(staff => ({
            ...staff,
            daysWorked: standardDays,
            incentives: 0,
            increase: 0,
            absentDays: 0,
            cashAdvance: 0,
            loan: 0,
            sss: 0, // Semi-monthly split
            philhealth: 0, // Semi-monthly split
            pagibig: 0 // Semi-monthly split
        }));
        setLedger(freshLedger);
    }, [standardDays]);

    // The core calculation engine for a single row
    const calculateRow = (row) => {
        const grossBase = row.daysWorked * row.rate;
        const totalGross = grossBase + Number(row.incentives) + Number(row.increase);
        
        const absentAmount = Number(row.absentDays) * row.rate;
        const totalDeductions = absentAmount + Number(row.cashAdvance) + Number(row.loan) + Number(row.sss) + Number(row.philhealth) + Number(row.pagibig);
        
        const netPay = totalGross - totalDeductions;

        return { grossBase, totalGross, absentAmount, totalDeductions, netPay };
    };

    // Handle typing into any input field dynamically
    const handleInputChange = (id, field, value) => {
        const numValue = value === '' ? 0 : parseFloat(value);
        setLedger(prevLedger => 
            prevLedger.map(row => 
                row.id === id ? { ...row, [field]: numValue } : row
            )
        );
        setIsSaved(false);
    };

    // Calculate bottom totals for the footer
    const totals = ledger.reduce((acc, row) => {
        const calc = calculateRow(row);
        return {
            grossBase: acc.grossBase + calc.grossBase,
            incentives: acc.incentives + Number(row.incentives),
            increase: acc.increase + Number(row.increase),
            totalGross: acc.totalGross + calc.totalGross,
            absentAmount: acc.absentAmount + calc.absentAmount,
            cashAdvance: acc.cashAdvance + Number(row.cashAdvance),
            loan: acc.loan + Number(row.loan),
            sss: acc.sss + Number(row.sss),
            philhealth: acc.philhealth + Number(row.philhealth),
            pagibig: acc.pagibig + Number(row.pagibig),
            totalDeductions: acc.totalDeductions + calc.totalDeductions,
            netPay: acc.netPay + calc.netPay,
        };
    }, { grossBase: 0, incentives: 0, increase: 0, totalGross: 0, absentAmount: 0, cashAdvance: 0, loan: 0, sss: 0, philhealth: 0, pagibig: 0, totalDeductions: 0, netPay: 0 });

    const handleSave = () => {
        // In the future, this is where the axios.post() goes to save to the database
        console.log("Saving Ledger to DB:", ledger);
        setIsSaved(true);
        setTimeout(() => setIsSaved(false), 3000);
    };

    return (
        <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', fontFamily: 'Arial, sans-serif' }}>
            
            {/* Control Panel (Hidden during Print) */}
            <div className="no-print" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '20px', borderBottom: '2px solid #e2e8f0', flexWrap: 'wrap', gap: '15px' }}>
                <div>
                    <h2 style={{ color: '#0ea5e9', margin: '0 0 5px 0', fontSize: '24px' }}>💰 Master Payroll Engine</h2>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>Auto-calculates semi-monthly cycle.</p>
                </div>
                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#475569' }}>Payroll Period</label>
                        <input type="text" value={periodStr} onChange={(e) => setPeriodStr(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#475569' }}>Standard Days</label>
                        <input type="number" value={standardDays} onChange={(e) => setStandardDays(Number(e.target.value))} style={{ padding: '8px', width: '80px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                        <button onClick={handleSave} style={{ padding: '10px 20px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>{isSaved ? '✅ Saved!' : '💾 Save to DB'}</button>
                        <button onClick={() => window.print()} style={{ padding: '10px 20px', backgroundColor: '#334155', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>🖨️ Print Sheet</button>
                    </div>
                </div>
            </div>

            {/* The Print Header (Only visible when printing) */}
            <div className="print-only" style={{ display: 'none', textAlign: 'center', marginBottom: '20px' }}>
                <h2 style={{ margin: '0', fontSize: '18px' }}>SAN HERMINIGILDO AGRO-INDUSTRIAL SCHOOL</h2>
                <p style={{ margin: '0', fontSize: '12px' }}>Alanib, Lantapan, Bukidnon</p>
                <h3 style={{ margin: '15px 0', fontSize: '14px', textDecoration: 'underline' }}>SALARIES AND WAGES OF TEACHERS FOR THE PERIOD: {periodStr}</h3>
            </div>

            {/* The Interactive Data Grid */}
            <div style={{ overflowX: 'auto', border: '1px solid #cbd5e1', borderRadius: '8px' }}>
                <table className="payroll-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'right', fontSize: '12px', minWidth: '1200px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #cbd5e1' }}>
                            <th style={{ padding: '10px', textAlign: 'left', borderRight: '1px solid #e2e8f0', borderBottom: '1px solid #cbd5e1' }} rowSpan="2">Name</th>
                            <th style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #cbd5e1', borderBottom: '1px solid #cbd5e1', backgroundColor: '#f8fafc' }} colSpan="3">Gross Calculation</th>
                            {/* Changed colSpan from 7 to 6 below, and added textAlign: 'center' */}
                            <th style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #cbd5e1', borderBottom: '1px solid #cbd5e1', backgroundColor: '#fee2e2' }} colSpan="6">Deductions</th>
                            <th style={{ padding: '10px', textAlign: 'center', backgroundColor: '#dcfce7', borderBottom: '1px solid #cbd5e1' }} rowSpan="2">Net Pay</th>
                        </tr>
                        <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #cbd5e1', textAlign: 'center' }}>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Rate/Day</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Incentive</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #cbd5e1' }}>Total Gross</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Abs. Days</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Abs. Amt</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Cash Adv.</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Loan</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>SSS/PH/PAG</th>
                            <th style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>Total Ded.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ledger.map((row, index) => {
                            const calc = calculateRow(row);
                            return (
                                <tr key={row.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                    <td style={{ padding: '8px', textAlign: 'left', fontWeight: 'bold', borderRight: '1px solid #e2e8f0' }}>{index + 1}. {row.name}</td>
                                    
                                    {/* GROSS SECTION */}
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0', color: '#64748b' }}>{row.rate.toFixed(2)}</td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>
                                        <input type="number" value={row.incentives === 0 ? '' : row.incentives} onChange={(e) => handleInputChange(row.id, 'incentives', e.target.value)} style={{ width: '60px', textAlign: 'right', border: '1px solid #cbd5e1', borderRadius: '4px' }} className="no-print-border" />
                                    </td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #cbd5e1', fontWeight: 'bold', backgroundColor: '#f1f5f9' }}>{calc.totalGross.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                                    
                                    {/* DEDUCTION SECTION */}
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0', backgroundColor: '#fef2f2' }}>
                                        <input type="number" step="0.5" value={row.absentDays === 0 ? '' : row.absentDays} onChange={(e) => handleInputChange(row.id, 'absentDays', e.target.value)} style={{ width: '40px', textAlign: 'center', border: '1px solid #fca5a5', borderRadius: '4px', backgroundColor: '#fff5f5' }} className="no-print-border" />
                                    </td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0', color: '#ef4444' }}>{calc.absentAmount > 0 ? calc.absentAmount.toFixed(2) : '-'}</td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>
                                        <input type="number" value={row.cashAdvance === 0 ? '' : row.cashAdvance} onChange={(e) => handleInputChange(row.id, 'cashAdvance', e.target.value)} style={{ width: '60px', textAlign: 'right', border: '1px solid #cbd5e1', borderRadius: '4px' }} className="no-print-border" />
                                    </td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0' }}>
                                        <input type="number" value={row.loan === 0 ? '' : row.loan} onChange={(e) => handleInputChange(row.id, 'loan', e.target.value)} style={{ width: '60px', textAlign: 'right', border: '1px solid #cbd5e1', borderRadius: '4px' }} className="no-print-border" />
                                    </td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #e2e8f0', display: 'flex', gap: '2px' }}>
                                        <input type="number" placeholder="SSS" value={row.sss === 0 ? '' : row.sss} onChange={(e) => handleInputChange(row.id, 'sss', e.target.value)} style={{ width: '45px', fontSize: '10px', textAlign: 'right', border: '1px solid #cbd5e1' }} className="no-print-border" />
                                        <input type="number" placeholder="PH" value={row.philhealth === 0 ? '' : row.philhealth} onChange={(e) => handleInputChange(row.id, 'philhealth', e.target.value)} style={{ width: '45px', fontSize: '10px', textAlign: 'right', border: '1px solid #cbd5e1' }} className="no-print-border" />
                                        <input type="number" placeholder="PAG" value={row.pagibig === 0 ? '' : row.pagibig} onChange={(e) => handleInputChange(row.id, 'pagibig', e.target.value)} style={{ width: '45px', fontSize: '10px', textAlign: 'right', border: '1px solid #cbd5e1' }} className="no-print-border" />
                                    </td>
                                    <td style={{ padding: '8px', borderRight: '1px solid #cbd5e1', fontWeight: 'bold', backgroundColor: '#fef2f2', color: '#dc2626' }}>{calc.totalDeductions > 0 ? calc.totalDeductions.toLocaleString('en-US', {minimumFractionDigits: 2}) : '-'}</td>
                                    
                                    {/* NET PAY */}
                                    <td style={{ padding: '8px', fontWeight: '900', color: '#166534', backgroundColor: '#f0fdf4', fontSize: '14px' }}>{calc.netPay.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr style={{ backgroundColor: '#1e293b', color: 'white', fontWeight: 'bold' }}>
                            <td style={{ padding: '12px', textAlign: 'left', borderRight: '1px solid #334155' }}>GRAND TOTALS</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155' }}>-</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155' }}>{totals.incentives.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155', color: '#38bdf8' }}>{totals.totalGross.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155' }}>-</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155', color: '#f87171' }}>{totals.absentAmount.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155', color: '#f87171' }}>{totals.cashAdvance.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155', color: '#f87171' }}>{totals.loan.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155', color: '#f87171' }}>{(totals.sss + totals.philhealth + totals.pagibig).toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', borderRight: '1px solid #334155', color: '#f87171' }}>{totals.totalDeductions.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                            <td style={{ padding: '12px', color: '#4ade80', fontSize: '16px' }}>{totals.netPay.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* ==========================================
                INDIVIDUAL PAYSLIP GENERATOR (PRINT ONLY)
                ========================================== */}
            <div className="print-slips-container" style={{ display: 'none' }}>
                {ledger.map((row, index) => {
                    const calc = calculateRow(row);
                    return (
                        <div key={row.id} className="payslip-ticket">
                            {/* Header */}
                            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                    <img src="/owl.png" alt="Logo" style={{ width: '30px' }} />
                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '11px', color: 'black' }}>San Herminigildo Agro-Industrial School</h4>
                                        <p style={{ margin: 0, fontSize: '9px', color: 'black' }}>P-4 Alanib, Lantapan, Bukidnon</p>
                                    </div>
                                </div>
                            </div>

                            {/* Meta Data */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid black', paddingBottom: '5px', marginBottom: '10px', fontSize: '11px' }}>
                                <span><strong>NO.</strong> {index + 1}</span>
                                <span><strong>Date:</strong> {periodStr}</span>
                            </div>

                            {/* Employee Info */}
                            <div style={{ marginBottom: '10px' }}>
                                <p style={{ margin: '0 0 5px 0', fontSize: '11px' }}>Employee Name:</p>
                                <p style={{ margin: 0, fontWeight: 'bold', fontSize: '13px', textAlign: 'center', textTransform: 'uppercase', borderBottom: '1px solid black', paddingBottom: '5px' }}>{row.name}</p>
                            </div>

                            {/* Orange Banner */}
                            <div style={{ backgroundColor: '#f97316', color: 'black', textAlign: 'center', fontWeight: 'bold', fontSize: '12px', padding: '4px', border: '1px solid black', marginBottom: '10px' }}>
                                PAY SLIP
                            </div>

                            {/* Financials */}
                            <div style={{ fontSize: '11px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}>
                                    <span>Basic Salary:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>₱ {calc.totalGross.toLocaleString('en-US', {minimumFractionDigits: 2})}</span>
                                </div>
                                
                                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold' }}>Less Deduction:</p>
                                
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Cash Advance:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{row.cashAdvance > 0 ? `₱ ${Number(row.cashAdvance).toFixed(2)}` : '₱'}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Loan:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{row.loan > 0 ? `₱ ${Number(row.loan).toFixed(2)}` : '₱'}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>SSS:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{row.sss > 0 ? `₱ ${Number(row.sss).toFixed(2)}` : '₱'}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Philhealth:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{row.philhealth > 0 ? `₱ ${Number(row.philhealth).toFixed(2)}` : '₱'}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Pag-ibig:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{row.pagibig > 0 ? `₱ ${Number(row.pagibig).toFixed(2)}` : '₱'}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Absent:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{calc.absentAmount > 0 ? `₱ ${calc.absentAmount.toFixed(2)}` : ''}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}>
                                    <span>Total Deduction:</span>
                                    <span style={{ borderBottom: '1px solid black', width: '50%', textAlign: 'right' }}>{calc.totalDeductions > 0 ? `₱ ${calc.totalDeductions.toLocaleString('en-US', {minimumFractionDigits: 2})}` : '₱'}</span>
                                </div>
                            </div>

                            {/* Net Pay & Signature */}
                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', fontSize: '14px', fontWeight: 'bold' }}>
                                <span>Net Pay:</span>
                                <span style={{ borderBottom: '2px solid black', width: '50%', textAlign: 'right', fontSize: '16px' }}>₱ {calc.netPay.toLocaleString('en-US', {minimumFractionDigits: 2})}</span>
                            </div>

                            <div style={{ marginTop: '40px', textAlign: 'center' }}>
                                <div style={{ borderTop: '1px solid black', width: '60%', margin: '0 auto', paddingTop: '5px', fontSize: '11px', color: 'black' }}>
                                    Cashier / Disbursed By
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            
        </div>
    );
};

export default Payroll;